import React from 'react';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Title from 'antd/lib/typography/Title';
import Paragraph from 'antd/lib/typography/Paragraph';
import styles from './maintenance.module.scss';
import error from 'assets/images/error.svg';

const Maintenance = () => {
  return (
    <Row className={styles.container} gutter={4}>
      <Col span={7}>
        <Title level={4}>We'll be back in just a minute!</Title>
        <Paragraph className={styles.para}>
          We're conducting some quick maintenance and will have the survey back up shortly.
        </Paragraph>
        <Paragraph className={styles.para}>
          Already submitted your survey responses? Rest assured we received them.
        </Paragraph>
        <Paragraph className={styles.para}>
          Still need to complete the survey or enter your payment details? Wait just a little longer
          and then refresh the page. We should be back in about 15 minutes.
        </Paragraph>
      </Col>
      <Col className={styles.rightCol} span={7}>
        <img className={styles.image} src={error} alt="Maintenance" />
      </Col>
    </Row>
  );
};

export default Maintenance;
